/* -------------------------------------------------------------------------- *
 * News & Events Popup *
 * -------------------------------------------------------------------------- *
 * Handles the logic for showing/hiding the popup based on cookies
 * and a data-attribute version string.
 */

const settings = {
    cookieName: 'newsPopup_version',
    delay: 2000, // 2 seconds
    selectors: {
        overlay: '#popup',
        settings: '#popup-settings',

        // Only the 'X' button closes the popup.
        closeTriggers: '.popup-close',
    },
};

/* --- Cookie Helpers --- */

const setCookie = (name, value, days) => {
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = `; expires=${date.toUTCString()}`;
    }
    document.cookie = `${name}=${value || ''}${expires}; path=/`;
};

const getCookie = (name) => {
    const nameEQ = `${name}=`;
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
};

/* ------------- *
 * Module Export *
 * ------------- */

const Popup = {
    settings,

    init() {
        const overlay = document.querySelector(settings.selectors.overlay);
        const settingsEl = document.querySelector(settings.selectors.settings);

        // 1. Safety check: ensure elements exist
        if (!overlay) return;

        // 2. Get Version
        // Fallback to 'default-v1' if element or attribute is missing
        const popupLastUpdated = settingsEl
            ? settingsEl.getAttribute('data-last-updated')
            : 'default-v1';

        // 3. Check Cookie
        const storedVersion = getCookie(settings.cookieName);

        // 4. Compare & Show
        // If cookie is missing OR versions don't match -> Show Popup
        if (!storedVersion || storedVersion !== popupLastUpdated) {
            setTimeout(() => {
                overlay.classList.add('is-visible');
            }, settings.delay);
        }

        // 5. Bind Events
        this.bindEvents(overlay, popupLastUpdated);
    },

    bindEvents(overlay, currentVersion) {
        const triggers = overlay.querySelectorAll(settings.selectors.closeTriggers);

        triggers.forEach((btn) => {
            btn.addEventListener('click', (e) => {
                e.preventDefault();
                this.close(overlay, currentVersion);
            });
        });
    },

    close(overlay, versionToSet) {
        overlay.classList.remove('is-visible');

        // Set cookie to expire in 15 days
        setCookie(settings.cookieName, versionToSet, 15);
    },
};

export default Popup;
